import React from 'react';

const TermsOfUse = () => {
  return (
    <div className='min-vh-100'>
      <h1>Terms of Use</h1>
      <p>
        Welcome to Deepstone Capital. These terms and conditions outline the rules and regulations for the use of Deepstone Capital's Website.
      </p>
      <h2>License</h2>
      <p>
        Unless otherwise stated, Deepstone Capital owns the intellectual property rights for all material on the website. All intellectual property rights are reserved.
      </p>
      <h2>Disclaimer</h2>
      <p>
        To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website and the use of this website.
      </p>
    </div>
  );
};

export default TermsOfUse;
